import type { BasePluginOptions } from '@atlaskit/editor-plugin-base';

interface Props {
	options: {
		__livePage?: boolean;
	};
}

export function basePluginOptions({ options }: Props): BasePluginOptions {
	return {
		allowInlineCursorTarget: true,
		allowScrollGutter: undefined,
	};
}
